import axios from "axios";

// ================= AUTH =================

const login = (credentials) =>
  axios.post("api/v1/auth/login", credentials);

// LF360-1970: the same login, answering with an HttpOnly cookie and no token.
// Nothing here stores anything afterwards, which is the whole point.
const loginWithCookie = (credentials) =>
  axios.post("api/v1/auth/portal/login", credentials);

// Kept for a caller that hands over a token it was given rather than one it
// stored — nothing does today. `session()` below is how the app asks who it is.
const loginByToken = (token) =>
  axios.get("api/v1/user", {
    headers: { Authorization: "Bearer " + token },
  });

/**
 * Who is this browser, if anyone?
 *
 * The first request the app makes: it cannot choose between the dashboard and
 * the login screen without an answer. A 401 is that answer for a visitor with
 * no session, not a failure.
 *
 * Deliberately the same endpoint the app has always read the user from, rather
 * than a new one saying the same thing in a second shape — the cookie
 * authorises it by itself now, and a bearer still does for as long as one is
 * around.
 */
const session = () => axios.get("api/v1/user");

const logout = () => axios.post("api/v1/auth/logout");

// LF360-1970: ends the cookie session on the server as well as in the browser.
// `POST /auth/logout` cannot: it authorises with the token it revokes, and a
// browser holding only a cookie has no header to fall back on.
const endSession = () => axios.delete("api/v1/auth/portal/session");

const checkToken = (token) =>
  axios.post("api/v1/auth/check-token", { token });

// ================= PASSWORD =================

const newPassword = ({ password, token, type }) => {
  console.log("TOKEN BEFORE REQUEST:", token);
  console.log("type BEFORE REQUEST:", type);

  if (type === "subject") {
    return axios.put("api/v1/subject/update-password-reset", {
      password,
      token,
    });
  }

  return axios.put(
    `api/v1/${type}/update-password`,
    { password },
    {
      headers: {
        Authorization: "Bearer " + token,
      },
    }
  );
};

const resetPassword = (email) =>
  axios.post("api/v1/user/reset-password", { email });

const updatePassword = (oldPassword, password) =>
  axios.put("api/v1/user/update-password", {
    password,
    oldPassword,
  });

// ================= PASSKEY =================

const passkeyLoginOptions = (payload) =>
  axios.post("api/v1/auth/user-passkey/login/options", payload);

const passkeyLoginVerify = (payload) =>
  axios.post("api/v1/auth/user-passkey/login/verify", payload);

// LF360-1970: the same verification, ending in a cookie instead of a token.
const passkeyLoginVerifyWithCookie = (payload) =>
  axios.post("api/v1/auth/portal/passkey-verify", payload);

const passkeyRegisterOptions = () =>
  axios.post("api/v1/auth/user-passkey/register/options");

const passkeyRegisterVerify = (payload) =>
  axios.post("api/v1/auth/user-passkey/register/verify", payload);

const passkeyList = () =>
  axios.get("api/v1/auth/user-passkey");

const passkeyDelete = (id) =>
  axios.delete(`api/v1/auth/user-passkey/${id}`);

const recordPasskeyPrompt = () =>
  axios.post("api/v1/user/record-passkey-prompt");

// ================= EXPORT =================

const getOauthAvailability = () =>
  axios.get("api/v1/auth/availability");


const ApiAuth = {
  login,
  loginWithCookie,
  loginByToken,
  session,
  logout,
  endSession,
  checkToken,
  newPassword,
  resetPassword,
  updatePassword,
  passkeyLoginOptions,
  passkeyLoginVerify,
  passkeyLoginVerifyWithCookie,
  passkeyRegisterOptions,
  passkeyRegisterVerify,
  passkeyList,
  passkeyDelete,
  recordPasskeyPrompt,
  getOauthAvailability
};

export default ApiAuth;